import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import axios, { axiosPrivate } from "../api/axios";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import { Dropdown } from "primereact/dropdown";

function ResultadosCFDIs({ Auth }) {
  const [registros, setRegistros] = useState(null);
  const [selectedResultados, setSelectedEmpresas] = useState(null);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [opciones, setOpciones] = useState([]);
  const [selectedEmpresa, setSeleccionado] = useState(null);
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedBimestre, setSelectedBimestre] = useState(null);
  const [expandedRows, setExpandedRows] = useState(null);

  const toast = useRef(null);
  const dt = useRef(null);
  const showMessage = (tipo, titulo, msg) => {
    toast.current.show({ severity: tipo, summary: titulo, detail: msg });
  };
  const onSelect = async (empresa, año, bimestre) => {
    try {
      const response = await axios.get("SUA/resultCFDIS", {
        params: {
          rfc: empresa,
          year: año,
          bimestre: bimestre,
        },
      });

      if (response.status === 200) {
        const data = response.data;
        console.log(data);
        setRegistros(data.datos);
      }
    } catch (error) {
      console.error("Error al obtener datos:", error);
      showMessage("error", "Error", error.message || "Error de conexión");
    }
  };
  useEffect(() => {
    if (selectedEmpresa && selectedYear && selectedBimestre) {
      onSelect(selectedEmpresa, selectedYear.code, selectedBimestre.code);
    }
  }, [selectedEmpresa, selectedYear, selectedBimestre]);
  useEffect(() => {
    const fetchDatos = async () => {
      try {
        console.log(Auth);
        const datosTransformados = Auth.Empresas.map((item) => ({
          label: item.nombre,
          value: item.rfc,
        }));
        setOpciones(datosTransformados);
      } catch (error) {
        console.error("Error al obtener datos:", error);
      }
    };
    fetchDatos();
  }, []);

  const seeRow = (product) => {
    console.log(product);
    let baseURL = window.location.origin;
    console.log(baseURL);
    baseURL = baseURL.replace("3000", "3500").replace("sua.", "api.");
    const url = `${baseURL}/SUA/resultExcel?year=${product.año}&bimestre=${product.bimestre}&rfc=${product.rfc}`;
    //window.open(url, "_blank");
  };

  const exportCSV = () => {
    dt.current.exportCSV();
  };
  const years = [{ name: "2025", code: "2025" }];

  const bimestres = [
    { name: "01", code: "01" },
    { name: "02", code: "02" },
    { name: "03", code: "03" },
    { name: "04", code: "04" },
    { name: "05", code: "05" },
    { name: "06", code: "06" },
  ];
  const leftToolbarTemplate = () => {
    return (
      <div className="flex flex-wrap gap-2">
        <div className="flex flex-column gap-2 mr-2">
          <label htmlFor="empresa">Empresa</label>
          <Dropdown
            id="empresa"
            value={selectedEmpresa}
            options={opciones}
            onChange={(e) => {
              setSeleccionado(e.value);
            }}
            optionLabel="label"
            optionValue="value"
            placeholder="Seleccione la empresa"
            className="w-full md:w-20rem"
          />
        </div>
        <div className="flex flex-column gap-2  mr-2">
          <label htmlFor="username">Año</label>
          <Dropdown
            value={selectedYear}
            onChange={(e) => setSelectedYear(e.value)}
            options={years}
            optionLabel="name"
            placeholder="Seleccione el año"
            className="w-full md:w-16rem"
          />
        </div>
        <div className="flex flex-column gap-2  mr-2">
          <label htmlFor="username">Bimestre</label>
          <Dropdown
            value={selectedBimestre}
            onChange={(e) => setSelectedBimestre(e.value)}
            options={bimestres}
            optionLabel="name"
            placeholder="Seleccione el bimestre"
            className="w-full md:w-16rem"
          />
          <small id="username-help"></small>
        </div>
      </div>
    );
  };

  const rightToolbarTemplate = () => {
    return (
      <Button
        label="Generar Excel"
        icon="pi pi-file-excel"
        className="p-button-success"
        onClick={handleExportExcel}
      />
    );
  };
  const handleExportExcel = async () => {
    if (!selectedEmpresa || !selectedYear || !selectedBimestre) {
      showMessage("warn", "Atención", "Seleccione empresa, año y bimestre");
      return;
    }
    try {
      const response = await axiosPrivate.get("/SUA/resultCFDIsExcel", {
        params: {
          rfc: selectedEmpresa,
          year: selectedYear.code,
          bimestre: selectedBimestre.code,
        },
        responseType: "blob", // 👈 importante para archivos
      });

      // Crear enlace de descarga
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `Reporte_${selectedEmpresa}_${selectedYear.code}_${selectedBimestre.code}.xlsx`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Error exportando:", error);
      showMessage("error", "Error", "No se pudo generar el archivo.");
    }
  };
  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-eye"
          rounded
          outlined
          className="mr-2"
          onClick={() => seeRow(rowData)}
        />
      </React.Fragment>
    );
  };

  const header = (
    <div className="flex flex-wrap gap-2 align-items-center justify-content-between">
      <h4 className="m-0"> </h4>
      <IconField iconPosition="left">
        <InputIcon className="pi pi-search" />
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Busqueda..."
        />
      </IconField>
    </div>
  );
  const rowExpansionTemplate = (rowData) => {
    return (
      <div className="p-3">
        <h5 className="mb-3">
          Comprobantes de {rowData.NSS}-{rowData.Nombre}
        </h5>
        <DataTable value={rowData.comprobantes} responsiveLayout="scroll">
          <Column field="uuid" header="UUID" style={{ minWidth: "20rem" }} />
          <Column
            field="fechaTimbrado"
            header="Fecha Timbrado"
            body={(rowData) => {
              const date = new Date(rowData.fechaTimbrado);
              return new Intl.DateTimeFormat("es-ES", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              }).format(date);
            }}
            style={{ minWidth: "10rem" }}
          />
          <Column
            field="fechaPago"
            header="Fecha Pago"
            body={(rowData) => {
              const date = new Date(rowData.fechaPago);
              return new Intl.DateTimeFormat("es-ES", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              }).format(date);
            }}
            style={{ minWidth: "10rem" }}
          />
          <Column
            field="importe"
            header="Importe"
            body={(d) =>
              new Intl.NumberFormat("es-MX", {
                style: "currency",
                currency: "MXN",
              }).format(d.importe)
            }
          />
        </DataTable>
      </div>
    );
  };

  return (
    <div>
      <h1>Recibos de nómina por bimestre</h1>
      <Toast ref={toast} />
      <div className="card">
        <Toolbar
          className="mb-4"
          left={leftToolbarTemplate}
          right={rightToolbarTemplate}
        ></Toolbar>
        <DataTable
          ref={dt}
          value={registros}
          expandedRows={expandedRows}
          onRowToggle={(e) => setExpandedRows(e.data)}
          rowExpansionTemplate={rowExpansionTemplate}
          selection={selectedResultados}
          onSelectionChange={(e) => setSelectedEmpresas(e.value)}
          dataKey="NSS"
          paginator
          rows={50}
          rowsPerPageOptions={[50]}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} products"
          globalFilter={globalFilter}
          header={header}
         stripedRows
        >
          <Column expander style={{ width: "3em" }} />
          <Column
            field="NSS"
            header="NSS"
            sortable
            style={{ minWidth: "12rem" }}
          ></Column>
          <Column
            field="Nombre"
            header="Nombre"
            sortable
            style={{ minWidth: "16rem" }}
          ></Column>
          <Column
            header="Importe total"
            body={(rowData) =>
              new Intl.NumberFormat("es-MX", {
                style: "currency",
                currency: "MXN",
                minimumFractionDigits: 2,
              }).format(rowData.totalImporte || 0)
            }
          ></Column>
          <Column
            header="# CFDIs"
            body={(rowData) => rowData.comprobantes?.length || 0}
            style={{ minWidth: "10rem" }}
          />
          {/* <Column
            body={actionBodyTemplate}
            exportable={false}
            style={{ minWidth: "12rem" }}
          ></Column> */}
        </DataTable>
      </div>
    </div>
  );
}
export default ResultadosCFDIs;
